import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useAndReportExperimentTreatment } from '../experiments';

import { useViewerCanAccessAnalyticsAdminSettings } from './selectors';

type UseShowAnalyticsSettings = () => boolean;
export const useShowAnalyticsSettings: UseShowAnalyticsSettings = () => {
  const isViewerCanAccessAnalyticsAdminSettings = useViewerCanAccessAnalyticsAdminSettings();
  const isVivaEngagePremium = useAndReportExperimentTreatment(Experiment.VivaEngagePremium) === true;

  return isVivaEngagePremium && isViewerCanAccessAnalyticsAdminSettings;
};
